import { createContext } from "react";

const GameInfoContext = createContext();

export default GameInfoContext;
